import React, { useCallback, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useWidth } from "../../../../../libs/hooks";
import { message } from "antd";
import { CardComponent } from "./card-component";
import { malimaxOneCount, workflowOneCount } from "../../../../../libs/apis";
import { CardWelcomeComponent } from "./card-welcome";
import MalimaxOneListComponent from "./table-malimax";

interface DataType {
  key: React.Key;
  name: string;
  age: number;
  address: string;
}

export const MalimaxComponent = ({ options }: { options: any[] }) => {
  const width = useWidth();
  const [valueOne, setValueOne] = useState("Hoy");
  const [totalOne, setTotalOne] = useState(0);

  useEffect(() => {
    handleGetData();
  }, []);

  const handleGetData = async () => {
    try {
      handleGetOne("hoy");
    } catch (err: any) {
      message.error(err.toString());
    }
  };
  const handleUpdateOne = useCallback(
    (val: string) => {
      const fill = options.find((el) => el.value === val);
      setValueOne(fill.label);
      handleGetOne(fill.value);
    },
    [valueOne]
  );

  const handleGetOne = async (value: string) => {
    try {
      const { data: dataOne } = await malimaxOneCount(value);
      if (!dataOne) return;
      setTotalOne(dataOne.total);
    } catch (err: any) {
      message.error(err.toString());
    }
  };

  return (
    <Grid container spacing={4} justifyContent="center">
      <Grid item xs={7} sm={4} lg={3}>
        <CardWelcomeComponent />
      </Grid>
      <Grid item xs={5} sm={2.5}>
        <CardComponent
          width={width}
          title="Malimax"
          quantity={totalOne}
          handleUpdate={handleUpdateOne}
          options={options}
          color="tomato"
          value={valueOne}
        />
      </Grid>
      <Grid item xs={12}>
        <MalimaxOneListComponent />
      </Grid>
    </Grid>
  );
};
